//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'CommunityHome',
  components: {
  },
  data: function() {
    return {
      slide: 1,
      featured_playlists: []
    }
  },
  methods: {
    openPlaylist: function(pname, pid) {
      this.$router.push("/community/playlist/" + pname + "/" + pid);
    },
    refreshFiles: async function(done) {
      if(this.$root.community.authToken == "") {
          //Log in to Webcenter
          await axios.post("https://webcenter.sisyphus-industries.com/auth_user", {
              email: this.$root.community.email, password: this.$root.community.password
          }).then((resp) => {
              this.$root.community.authToken = resp.data.resp[0].auth_token;
          });
      }

      //Get featured playlists to put at top of page
      await axios.get("https://webcenter.sisyphus-industries.com/playlists.json", { headers: {Authorization: this.$root.community.authToken }}).then((response) => {
        const playlists = response.data.resp;
        playlists.forEach(playlist => {
            if(playlist.is_featured) {
                playlist.thumburl = "https://webcenter.sisyphus-industries.com/uploads/track/thr/" + playlist.db_tracks[playlist.featured_track] + "/thumb_400.png";
                this.featured_playlists.push(playlist);
            }
        });
      });
      done();
    }
  },
  mounted: function() {
    this.refreshFiles();
  }
}
